import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNotificationsSelectedNavIcon(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M10.4 1c3.65 0 4.97 1.8 5.61 3.65l1.22 6.08 1.58 3.65H2l1.55-3.65 1.22-6.08C5.41 2.8 6.76 1 10.4 1ZM6.94 15.63c.49 1.58 1.85 2.73 3.47 2.73s2.98-1.15 3.47-2.73H6.94Z",
    fill: "currentColor"
  }));
}

export { SvgNotificationsSelectedNavIcon as default };
